import { SectionHelper, Text } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import React, { useEffect } from 'react';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
export const TextInImageMessage = _ref => {
  let {
    elementStatus,
    elementIndex
  } = _ref;
  const biLogger = useBiLogger();
  useEffect(() => {
    biLogger.elementNotificationView({
      elementIndex,
      elementStatus,
      notificationType: 'text in image'
    });
  }, [biLogger, elementIndex, elementStatus]);
  return /*#__PURE__*/React.createElement(SectionHelper, {
    size: "small"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      bold: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: "accessibility-wizard.rules-list.alt-image.text-in-image.section-helper.content"
  })));
};
//# sourceMappingURL=text-in-image-message.js.map